//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import TagManager from 'react-gtm-module';

//childrens
import DialogPDF from "../childrens/content/.mixins";
import CustomToolbar from "../childrens/customToolbar/.mixins";
import CustomSort from "../childrens/customSort/.mixins";
import Colunms from "../childrens/columns/.mixins";
import { AuthContext } from '../../../../../../contexts/AuthContext';

//controllers
import Protocolos_controller from '../../../../../../controllers/protocolo';
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';
import Pessoa_controller from '../../../../../../controllers/pessoa';

export default class Protocolos extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();
        this.permissions  = {};

        this.state = {
            title: 'Protocolos de Agendamento',
            itensTable: [],
            columns: [],
            isLoading: false,
            isLoadingDatas: false,
            isError: false,
            error: null,
            fontSize: '8pt',
            rowsPerPage: 10,
            padding: '2px',
            nameCSV: 'Protocolos',
            dataAgenda: null,
            listaDatas: [],
            modal: false,
            modalPDF: false,
            modalPDFUserData: null,
            filters: {
                datas: false,
                flagsPag: false,
                adminFilter: false,
            },
            fornecedor: 0,
            customSort: CustomSort,
            customToolbar: null
        }

        this.loadData = this.loadData.bind(this);
        this.loadDatas = this.loadDatas.bind(this);
        this.loadUserData = this.loadUserData.bind(this);
        this.actionImprimir = this.actionImprimir.bind(this);
        this.setState = this.setState.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOpenPDF = this.handleOpenPDF.bind(this);
        this.handleClosePDF = this.handleClosePDF.bind(this);
    }

    componentWillMount() {
        this.permissions = this.context.user.permissions;

        this.setState({
            filters: {
                ...this.state.filters,
                adminFilter: !!this.permissions["filtro-fornecedor"],
            }
        });
        
        this.loadCustoms();
        this.loadDatas();
        this.loadUserData();
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:protocolos',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-protocolos',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela Protocolo!");
    }

    handleOpenPDF(){
        this.setState({ modalPDF: true });

        TagManager.dataLayer({
            dataLayer: {
              event: 'event',
              eventCategory: 'tokstok:fornecedores:protocolos',
              eventAction: 'clique:pdf',
              eventLabel: moment(this.state.dataAgenda,"DD/MM/YYYY").format("YYYY-MM-DD"),
            }
        });
    };
    
    handleClosePDF(){
        setTimeout(() => {
            this.setState({ modalPDF: false });
        }, 200);
    };

    handleClickOpen() {
        this.setState({modal:true});
    };

    handleClose() {
        this.setState({modal:false});
    };

    handleChange(value) {
        this.setState({dataAgenda: value.dt});
        this.loadData(value.dt);

        TagManager.dataLayer({
            dataLayer: {
              event: 'event',
              eventCategory: 'tokstok:fornecedores:protocolos',
              eventAction: 'clique:data',
              eventLabel: moment(value.dt,"DD/MM/YYYY").format("YYYY-MM-DD")
            }
        });
    };

    loadCustoms() {
        this.setState({
            customToolbar:() => <CustomToolbar {...this}/>,
        });
    }

    async loadData(data) {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            var filters = {};
            if (data.dataFim) {
                this.setState({
                    isLoading: true
                });
                filters["dataAgenda"] = this.state.dataAgenda;
                filters["idFornecedor"] = this.state.fornecedor;
            } else {
                this.setState({
                    dataAgenda: data,
                    isLoading: true
                });
                filters["dataAgenda"] = data;
                filters["idFornecedor"] = this.state.fornecedor;
            }
            var json = JSON.parse(await Protocolos_controller.getProtocolos(token,filters));
            if (json.status) {

                this.setState({
                    itensTable: json.itens,
                    isLoading: false,
                    columns: Colunms,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //         event: 'event',
                //         eventCategory: 'tokstok:fornecedores:protocolos',
                //         eventAction: 'callback',
                //         eventLabel: `sucesso:lista-protocolos`,
                //     }
                // });
                
            } else {
                if (
                    json.status == false && 
                    json.message && 
                    json.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
            this.setState({
                isLoading: false
            });
            this.handleClose();
            this.loadDatas();
        } catch (error) {
            this.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:protocolos',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }

    }

    async loadDatas() {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            this.setState({
                isLoadingDatas: true
            });
            const filters = {
                idFornecedor: this.state.fornecedor
            };
            const o_protocolo = await Protocolos_controller.getProtocoloDatas(token,filters);
            const j_protocolo = JSON.parse(o_protocolo.body);
            if (o_protocolo.res.statusCode === 200) {
                
                //prepara dados para tabela
                var arrayItens = [];
                j_protocolo.itens.forEach(element => {
                    arrayItens.push({dt: element.DT_AGENDA.substr(0, element.DT_AGENDA.indexOf(' '))});
                });

                this.setState({
                    listaDatas: arrayItens,
                    isLoadingDatas: false
                });
                
                // TagManager.dataLayer({
                //     dataLayer: {
                //         event: 'event',
                //         eventCategory: 'tokstok:fornecedores:protocolos',
                //         eventAction: 'callback',
                //         eventLabel: `sucesso:lista-datas`,
                //     }
                // });
                
            } else {
                if (
                    j_protocolo.status == false && 
                    j_protocolo.message && 
                    j_protocolo.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

        } catch (error) {
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
            errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });
            this.child.current.retorno(errorString,'error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:protocolos',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    }

    loadUserData = async () => {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');
    
        try {
            var o_usuario = await Pessoa_controller.getByToken(token);
            var j_usuario = JSON.parse(o_usuario.body);
            if (o_usuario.res.statusCode === 200) {
                const pdfUserData = `${j_usuario.itens.nome} (${j_usuario.itens.codigo})`;
                this.setState({modalPDFUserData: pdfUserData});

                //auditoria
                var str = "Efetuada requisição para retorno de dados de pessoa! "
                +"Response:( Method: "+o_usuario.res.request.method
                +", StatusCode: "+o_usuario.res.statusCode
                +", Body: (limited 100chars)"+o_usuario.body.substr(0,100)
                +" )";
                Log.info(token,str);

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:protocolos',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:${pdfUserData}`,
                //     }
                // });
            } else {
                throw new Error("Campos necessários, não foram retornados pelo servidor!");
            }
        } catch (error) {
            this.child.current.retorno('Não foi possível carregar infomações de usuário!','error');
            var errorString = "Não foi possível carregar infomações de usuário!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });

            //auditoria
            var str = "Erro no retorno de dados de pessoa! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:protocolos',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
        
    }

    actionImprimir = () => {
        this.handleOpenPDF();

        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        var str = "Usuário solicitou impressão PDF do protocolo de agendamento! Token "+token;
        Log.info(token,str);
    };

    render() {
        return (
            <>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Protocolos`}</title>
                </Helmet>
                <DialogPDF {...this}/>
            </>
        );
    }

}